import {
  API_DELETE_SUPPRESSED_EMAIL,
  API_GET_SUPPRESSED_EMAILS,
  API_PUT_SUPPRESSED_EMAIL,
} from "@/config/api.config";
import apiCall from "@/utils/api";

export const FETCH_SUPPRESSED_EMAILS = "FETCH_SUPPRESSED_EMAILS";
export const SET_SUPPRESSED_EMAILS = "SET_SUPPRESSED_EMAILS";
export const DELETE_SUPPRESSED_EMAIL = "DELETE_SUPPRESSED_EMAIL";
export const UPDATE_SUPPRESSED_EMAIL = "UPDATE_SUPPRESSED_EMAIL";

export default {
  [FETCH_SUPPRESSED_EMAILS]({ commit }, { params } = {}) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    return new Promise((resolve, reject) => {
      apiCall({
        method: API_GET_SUPPRESSED_EMAILS,
        params,
      })
      .then((response) => {
        const { status, data } = response;

        if (status === 200 && !data.error) {
          commit(SET_SUPPRESSED_EMAILS, data.data);
          commit('SET_LOADING', false);
          resolve(data);
        } else {
          commit('SET_ERROR', data.details || 'Failed to fetch suppressed emails');
          commit('SET_LOADING', false);
          reject(data);
        }
      })
      .catch((error) => {
        commit('SET_ERROR', error.message || 'An error occurred');
        commit('SET_LOADING', false);
        reject(error);
      });
    });
  },
  [DELETE_SUPPRESSED_EMAIL]({ commit }, email) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    return new Promise((resolve, reject) => {
      apiCall({
        method: API_DELETE_SUPPRESSED_EMAIL,
        parts: { email },
      })
        .then((response) => {
          const { status, data } = response;

          if (status === 200 && !data.error) {
            commit('SET_LOADING', false);
            resolve(data);
          } else {
            commit('SET_ERROR', data.details || 'Failed to delete suppressed email');
            commit('SET_LOADING', false);
            reject(data);
          }
        })
        .catch((error) => {
          commit('SET_ERROR', error.message || 'An error occurred');
          commit('SET_LOADING', false);
          reject(error);
        });
    });
  },
  [UPDATE_SUPPRESSED_EMAIL]({ commit }, { email, data }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    return new Promise((resolve, reject) => {
      apiCall({
        method: API_PUT_SUPPRESSED_EMAIL,
        parts: { email },
        data: { data },
      })
        .then((response) => {
          const { status, data } = response;
          if (status === 200 && !data.error) {
            commit("SET_LOADING", false);
            resolve(data);
          } else {
            commit("SET_ERROR", data.details || "Failed to update suppressed email");
            commit("SET_LOADING", false);
            reject(data);
          }
        })
        .catch((error) => {
          commit("SET_ERROR", error.message || "An error occurred");
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};
